import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import {GetExtraTokenShowDataTypes} from "../../../../Schema/getExtraTokenShow.types";
export type GetExtraTokenShowLoadAction = {
  type: string;
  payload: {};
};

export type GetExtraTokenShowData = {
  data: GetExtraTokenShowDataTypes
};

const GetExtraTokenShow = new ReduxFetchState<GetExtraTokenShowData, {}, any>("getExtraTokenShow");

export function* watchGetExtraTokenShow(action: GetExtraTokenShowLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetExtraTokenShowData = yield axios({
      url: `/api/v1/ai/subscription/extra-token/show`,
      method: "GET",
      headers: {
        lang,
      },
    });

    yield put(GetExtraTokenShow.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    console.log(e, "error is here");
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetExtraTokenShow.actions.loadFailure(e.message));
  }
}

export function* getExtraTokenShowSagas() {
  yield takeEvery(GetExtraTokenShow.actionTypes.load, watchGetExtraTokenShow);
}

export function useGetExtraTokenShow() {
  const { loading, data, ...getExtraTokenShowState } = useAppSelector((state) => state.getExtraTokenShow);
  const dispatch = useAppDispatch();

  const dispatchGetExtraTokenShow = useCallback(() => {
    dispatch(GetExtraTokenShow.actions.load());
  }, [dispatch]);

  return {
    ...getExtraTokenShowState,
    dispatchGetExtraTokenShow,
    getExtraTokenShowLoading: loading,
    getExtraTokenShowData: data,
  };
}

export const {
  actionTypes: getExtraTokenShowActionsTypes,
  actions: getExtraTokenShowActions,
  reducer: getExtraTokenShowReducer,
} = GetExtraTokenShow;